module.exports = __webpack_public_path__ + "img/volume-off.933b5ef4.svg";